module.exports = __webpack_public_path__ + "static/ebaa550d.card_2.png";